<div *ngIf="project" class="container-fluid py-4">
  <app-header-title
    [dataTestId]="'page-title-hint'"
    [titleHint]="'MANAGE_PROJECT_TITLE'"
    [link]="LINK_PROJECTS_VIEW"
    [itemId]="project.entity_id"
    [title]="project.title"
  ></app-header-title>
  <ul ngbNav #nav="ngbNav" type="pills" (navChange)="onTabClick($event)" class="nav-tabs">
    <li ngbNavItem="updateData">
      <a ngbNavLink>
        {{ 'PROJECT_TAB_INFO' | translate }}
      </a>

      <ng-template ngbNavContent>
        <app-update-project
          [project]="project"
          [formContent]="formContent$ | async"
          (removeProject)="onRemoveProject($event)"
          (updateProject)="onUpdateProject($event)"
          (dirtyForm)="setFormStatus($event)"
        ></app-update-project>
      </ng-template>
    </li>
    <li ngbNavItem="userRequestsJoin">
      <a ngbNavLink [attr.data-test-id]="'userRequestsJoin'">
        {{ 'PROJECT_TAB_REQUESTS_JOIN' | translate }} ({{ receivedCounter }})
      </a>

      <ng-template ngbNavContent>
        <app-spinner>
          <app-grid-users-list
            [currentPage]="resolver.state.pagination?.currentPage"
            [pageSize]="pageSize"
            [totalCount]="resolver.state.pagination?.totalItemsCount"
            (pageChange)="resolver.onPageChanged($event)"
            [pagination]="true"
            [constructorData]="tableData$ | async"
            [noUsersHint]="'NO_PROJECT_USER_REQUESTS_TEXT'"
            [sortOptions]="SORT_OPTIONS"
            [currentSortCategory]="currentSortCategory"
            [ascending]="ascending"
            (action)="onTableAction($event)"
            (toggleSorting)="onSortParamChanged($event)"
            (toggleSortingByType)="toggleSortingOrderByType($event)"
          ></app-grid-users-list>
        </app-spinner>
      </ng-template>
    </li>
    <li ngbNavItem="pendingInvitations">
      <a ngbNavLink [attr.data-test-id]="'pendingInvitations'">
        {{ 'PROJECT_TAB_PENDING_INVITATIONS' | translate }} ({{ sentCounter }})
      </a>

      <ng-template ngbNavContent>
        <app-spinner>
          <app-grid-users-list
            [currentPage]="resolver.state.pagination?.currentPage"
            [pageSize]="pageSize"
            [totalCount]="resolver.state.pagination?.totalItemsCount"
            (pageChange)="resolver.onPageChanged($event)"
            [pagination]="true"
            [constructorData]="tableData$ | async"
            [noUsersHint]="'NO_PROJECT_INVITES_TEXT'"
            [sortOptions]="SORT_OPTIONS"
            [currentSortCategory]="currentSortCategory"
            [ascending]="ascending"
            (action)="onTableAction($event)"
            (toggleSorting)="onSortParamChanged($event)"
            (toggleSortingByType)="toggleSortingOrderByType($event)"
          ></app-grid-users-list>
        </app-spinner>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
